<template>
  <el-dialog
    :title="$t('setting.设置')"
    v-bind="$attrs"
    class="dialog-dark setting-dialog"
    :close-on-click-modal="false"
    v-on="$listeners"
    width="709px"
    @close="closeDialog"
  >
    <el-tabs tab-position="left" v-model="activeName">
      <el-tab-pane :label="$t('setting.功能设置')" name="show">
        <div class="func-container">
          <div v-if="role == 3" class="win-switch">
            <span style="margin-right: 20px">{{
              $t("setting.嘉宾端显示观众列表")
            }}</span>
            <el-switch
              class="switch--mini"
              v-model="partShowListSwitch"
              active-color="#3986EE"
              :width="28"
              @change="changePartShowListSwitch"
            >
            </el-switch>
          </div>
          <div class="win-switch">
            <span style="margin-right: 20px">{{
              $t("setting.观众窗口跟随切换")
            }}</span>
            <el-switch
              class="switch--mini"
              v-model="winSwitch"
              active-color="#3986EE"
              :width="28"
              @change="winSwitchChange"
            >
            </el-switch>
            <div class="win-switch-tip">{{ $t("setting.注") }}</div>
          </div>
          <div class="win-switch form-dark">
            <span style="margin-right: 20px">{{
              $t("setting.多语言选项")
            }}</span>
            <el-select
              v-model="language"
              :placeholder="$t('setting.请选择')"
              @change="changeLanguage"
            >
              <el-option
                v-for="item in languages"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane
        :label="$t('setting.推流设置')"
        v-if="role == 3"
        name="pushStream"
      >
        <pushstream></pushstream>
      </el-tab-pane>
      <el-tab-pane :label="$t('setting.音视频设置')" name="media">
        <media></media>
      </el-tab-pane>
      <!-- 云播临时需求 -->
      <el-tab-pane :label="$t('setting.关于产品')" name="about">
        <about />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import { Tabs, TabPane } from "element-ui";
import pushstream from "@/components/setting/pushstream";
import media from "@/components/setting/media";
import about from "@/components/setting/about"; // 云播临时需求
import Bus from "@/components/doc/bus";
// setGuestSeeAuth
import { setGuestSeeAuth } from "@/api/liveRequest/liveInfo";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
import { getLiveInfo } from "@/api/liveRequest/liveInfo";
import enLocale from 'element-ui/lib/locale/lang/en'
import cnLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import locale from 'element-ui/lib/locale'
import { mapMutations } from "vuex";

export default {
  name: "setting",
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    pushstream,
    media,
    about, // 云播临时需求
  },
  watch: {
    "$attrs.visible": {
      handler(value) {
        this.winSwitch = sessionStorage.getItem(this.mainStatusKey) === "1";
        if (!value) {
          Bus.$emit("stopMic");
        } else {
          this.getLiveInfo();
          this.partShowListSwitch = this.guestSeeAuth == 1 ? true : false;
          Bus.$emit("initMedia");
        }
      },
    },
    settingShow: {
      immediate: true,
      handler: function () {
        this.activeName = "media";
      },
    },
  },
  mounted() {
    pushRoomMessageFunc((msg) => {
      this.getCvMcRoomMessage(msg);
    });
  },
  computed: {
    settingShow() {
      return this.$store.getters.setting;
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
    userInfo() {
      return this.$store.getters.userInfo;
    },
    liveToken() {
      return this.$store.getters.liveToken;
    },
    guestSeeAuth() {
      return this.$store.getters.guestSeeAuth;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    mainStatusKey() {
      return this.$store.getters.mainStatusKey;
    },
  },
  data() {
    return {
      openSetting: false,
      partShowListSwitch: false,
      activeName: "show",
      winSwitch: false,
      languages: [
        {
          value: "zh-CN",
          label: "简体中文",
        },
        {
          value: "zh-TW",
          label: "繁体中文",
        },
        {
          value: "en-US",
          label: "English",
        },
      ],
      language: this.$i18n.locale,
    };
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    closeDialog() {
      this.$store.commit("SHOW_SETTING", false);
    },
    changePartShowListSwitch() {
      console.log(this.partShowListSwitch);
      const stat = this.partShowListSwitch ? 1 : 2;
      setGuestSeeAuth(stat, this.liveToken).then((res) => {
        if (res && res.code != 200) {
          this.$message.warning(res.msg);
        } else {
          const tips = this.partShowListSwitch
            ? this.$t("setting.开启成功")
            : this.$t("setting.关闭成功");
          this.$message.success(tips);
        }
      });
    },
    winSwitchChange() {
      sessionStorage.setItem(this.mainStatusKey, this.winSwitch ? 1 : 0);
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7127: {
          let _requestData = msg.requestData;
          if (_requestData.event && _requestData.event === "guest_see_auth") {
            this.$store.commit("SET_GUESTSEEAUTH", _requestData.status);
          }
        }
      }
    },
    getLiveInfo() {
      getLiveInfo(this.liveId).then((res) => {
        if (res && res.code == 200) {
          this.$store.commit("SET_LIVECONFIG", res.data.broadcastSettingInfo);
          this.$store.commit("SET_LIVEROOMTYPE", res.data.liveRoomType);
        } else {
          Bus.$emit("loginerror", { info: res.msg });
        }
      });
    },
    changeLanguage() {
      this.$i18n.locale = this.language;
      this.$root.$i18n.locale = this.language;
      if(this.$i18n.locale == 'zh-CN'){
        locale.use(cnLocale)
      }else if(this.$i18n.locale == 'zh-TW'){
        locale.use(twLocale)
      }else{
        locale.use(enLocale)
      }
      this.$store.commit("setLanguage", this.language);
    },
  },
};
</script>

<style lang="scss">
.func-container {
  background-color: #2d304f;
  height: 392px;
  text-align: left;
  padding: 40px 0px 0px 40px;
  font-size: 14px;
  .win-switch {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    flex-wrap: wrap;
  }
  .switch--mini{
    margin-right: 20px
  }
  .win-switch-tip {
    font-size: 12px;
    color: #acb2bf;
  }
}
.el-popper {
  border: 1px solid #444767;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  border-bottom-color: #444767;
}
.el-popper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #2d3052;
}

</style>
